import React from "react";
import { Formik, Form, FieldArray } from "formik";
import { Button } from "antd";
import {
    ExpressionLine,
    AddButtonArea,
    DeleteButtonArea,
    SubmitButtonArea,
    Container
} from "./Styled";
import { Input, Select } from 'formik-antd';
import { Flow } from "../../../../../model/workflowEditor/flow/types";
import { H1 } from "../ComponentMenu/Styled";
import { RootState } from "../../../../../model/rootReducer";
import { useSelector } from "react-redux";
import SaveButton from "../../../../system/saveButton/SaveButton";

type BotMessageFormProps = {
    flow: Flow;
    onChange: (flow: Flow) => void;
};

export const SlotManager: React.FunctionComponent<BotMessageFormProps> = ({
    flow,
    onChange
}) => {
    const entities = useSelector((state: RootState) => state.entity.entities)
    return (
        <Container>
            <H1>SLOTS</H1>
            <Formik
                initialValues={{ flow: flow }}
                onSubmit={({ flow }) => {
                    onChange(flow);
                }}
                render={({ values }) => (
                    <Form>
                        <FieldArray
                            name="flow.slots"
                            render={arrayHelpers => (
                                <div>
                                    {
                                        values.flow?.slots?.map((slotItem, index) => (
                                            <ExpressionLine key={index}>
                                                <Input name={`flow.slots.${index}.name`} placeholder='Name'></Input>
                                                <Select
                                                    name={`flow.slots.${index}.entityId`}
                                                    showSearch
                                                    style={{ width: '100%' }}
                                                    placeholder="Pick a type"
                                                    optionFilterProp="children"
                                                    filterOption={(input, option) =>
                                                        option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                >
                                                    {entities.map(({ id, title }) => { return <Select.Option value={id!}>{title}</Select.Option> })}
                                                </Select>
                                                <DeleteButtonArea>
                                                    <Button
                                                        danger
                                                        onClick={() => arrayHelpers.remove(index)} // remove a friend from the list
                                                    >
                                                        -
                                                    </Button>
                                                </DeleteButtonArea>
                                            </ExpressionLine>
                                        ))
                                    }
                                    <AddButtonArea>
                                        <Button
                                            onClick={() => arrayHelpers.push("")} // insert an empty string at a position
                                        >
                                            +
                                        </Button>
                                    </AddButtonArea>
                                    <SubmitButtonArea>
                                        <SaveButton/>
                                    </SubmitButtonArea>
                                </div>
                            )}
                        />
                    </Form>
                )}
            />
        </Container>
    )
};
